import { environment } from './../../environments/environment';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Candidato } from '../models/candidato.model';
import { catchError } from 'rxjs/operators';
import { BlacklistComponent } from '../pages/gestor/parametrizacoes/blacklist/blacklist.component';
import { Blacklist } from '../models/blacklist.model';

@Injectable({
    providedIn: 'root'
})

export class BlacklistService {
    blacklist: BlacklistComponent;
    configHeader: { headers: { Authorization: any; }; };
    constructor(
        private http: HttpClient
    ) { }

    public getBlackListByEleicaoId(token: any, eleicaoId: number) {
        return new Promise((resolve, reject) => {
            this.configHeader = { headers: { 'Authorization': token } }
            this.http.get(`${environment.url_api}/eleicoes/${eleicaoId}/blacklist`, this.configHeader).subscribe(
                payload => {
                    resolve(payload)
                }, err => {
                    reject(err.error.message);
                })
        })
    }

    public atualizaLoginNaBlacklist(token: any, login: Blacklist, loginId: number) {
        return new Promise((resolve, reject) => {
            this.configHeader = { headers: { 'Authorization': token } }
            this.http.put(`${environment.url_api}/blacklist/${loginId}`, login, this.configHeader).subscribe(
                payload => {
                    resolve(payload)
                }, err => {
                    reject(err.error.message);
                })
        })
    }

    public deletaLoginNaBlacklist(token: any, blacklistId: number) {
        return new Promise((resolve, reject) => {
            this.configHeader = { headers: { 'Authorization': token } }
            this.http.delete(`${environment.url_api}/blacklist/${blacklistId}`, this.configHeader).subscribe(
                payload => {
                    resolve(payload)
                }, err => {
                    reject(err.error.message);
                })
        })
    }

    public inserirLoginNaBlacklist(token: any, login: Blacklist) {
        return new Promise((resolve, reject) => {
            this.configHeader = { headers: { 'Authorization': token } }
            this.http.post(`${environment.url_api}/blacklist`, login, this.configHeader).subscribe(
                payload => {
                    resolve(payload)
                }, err => {
                    reject(err.error.message);
                })
        })
    }

    public inserirLoginsNaBlackListEmMassa(token: any, listaLogin: any) {
        return new Promise((resolve, reject) => {
            this.configHeader = { headers: { 'Authorization': token } }
            this.http.post(`${environment.url_api}/blacklist/bulk`, listaLogin, this.configHeader).subscribe(
                payload => {
                    resolve(payload)
                }, err => {
                    reject(err.error.message);
                })
        })
    }
}